import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PortalProjectObject } from '../_models/project_portal_objects';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PortalObjectsService {

  constructor(private http: HttpClient) {
  }
  getProjects(): Observable<PortalProjectObject[]> {
    return this.http.get<PortalProjectObject[]>(environment.apiUrl + `/projects`);
    // .pipe(
    //   tap(_ => this.logService.log(this.className, 'fetched projects'))
    // );
  }
  getPortalObjects(): Observable<PortalProjectObject[]> {
    return this.http.get<PortalProjectObject[]>(environment.apiUrl + `/projects/objects`);
    // .pipe(
    //   tap(_ => this.logService.log(this.className, 'fetched projects'))
    // );
  }

  getObjectsForProject(projectid: number): Observable<PortalProjectObject[]> {
    return this.http.get<PortalProjectObject[]>(environment.apiUrl + `/projects/${projectid}/objects`);
    // .pipe(
    //   tap(_ => this.logService.log(this.className, 'fetched projects'))
    // );
  }
}
